import { Table } from "dyl-components";
import {
    Table as SemanticTable,
} from "semantic-ui-react";
import React from "react";
import QuoteItemRow from "./QuoteItemRow";

const QuoteItemsTable = ({ quote, cart, disabled, isOrder, canceled_order, onPromptTaxCalculation, shouldNotDisplayPriceChanges, catalog_discounts }) => {
    return (
        <Table striped={false}>
            <Table.Header>
                <Table.Row>
                    <SemanticTable.HeaderCell width={2}>
                        Product
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={3}>
                        Description
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={2}>
                        Pricing Schedule
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={2}>
                        Price
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={1}>
                        Quantity
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={1}>
                        Sum
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={1}>
                        Discount
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={2}>
                        Discount Expiration
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={1}>
                        Prorated
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={2}>
                        Subtotal
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell width={1}>
                        Actions
                    </SemanticTable.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {cart.map((item, index) => (
                    <QuoteItemRow
                        index={index}
                        item={item}
                        key={item.key}
                        quote={quote}
                        disabled={disabled}
                        isOrder={isOrder}
                        canceled_order={canceled_order}
                        onPromptTaxCalculation={onPromptTaxCalculation}
                        shouldNotDisplayPriceChanges={shouldNotDisplayPriceChanges}
                        item_discount={catalog_discounts?.find((discount) => discount.product_id === item.id)}

                    />
                ))}
            </Table.Body>
        </Table>
    );
};

export default QuoteItemsTable;
